<template>
	<div class="d-flex-between-center align-items-center p-x-20 p-y-12 bg-white">
		<div class="d-block">
			<div class="f-regular f-14 f-c-black">
				Proses ekspor sudah selesai
			</div>
			<div class="f-regular f-12 f-c-midgrey">
				File siap di-download
			</div>
		</div>
		<div class="d-flex">
			<SOButton
				class="p-r-12"
				:text="'Download Data'"
				:outline="true"
				@action="download"
			/>
			<img src="@/assets/icons/closeblue.svg" alt="" @click="() => { pageSetting.modal.deleteExport = true }">
		</div>


		<SOModalExportMultipleFile
			:export-data="exportData"
			:delete-cluster-actions="deleteClusterActions"
			:delete-master-actions="deleteMasterActions"
			v-if="pageSetting.modal.multipleExport"
			@close="() => { pageSetting.modal.multipleExport = false }"
			@downloaded="downloaded"
			@done="done"
		/>
		<SOModalConfirmDeleteExport
			v-if="pageSetting.modal.deleteExport"
			:export-data-length="exportData.length"
			@close="() => { pageSetting.modal.deleteExport = false }"
			@dismiss-export="dismissExport"
		/>
	</div>
</template>

<script>
import SOButton from "@/so-components/global/ui/SOButton";
import SOModalExportMultipleFile from "@/so-components/global/modal/SOModalExportMultipleFile";
import SOModalConfirmDeleteExport from "@/so-components/global/modal/SOModalConfirmDeleteExport";

export default {
	name: "SOExportMultipleFile",
	components: {
		SOButton,
		SOModalExportMultipleFile,
		SOModalConfirmDeleteExport,
	},
	props: {
		exportData: Array,
		exportDataLength: Number,
		deleteClusterActions: String,
		deleteMasterActions: String,
	},
	data() {
		return {
			pageSetting: {
				modal: {
					multipleExport: false,
					deleteExport: false,
				}
			}
		}
	},
	methods: {
		close() {
			$("#modal-delete-export").modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		done() {
			this.$emit("done")
		},
		download() {
			if (this.exportDataLength > 1000) {
				this.pageSetting.modal.multipleExport = true
			} else {
				this.downloadFile(this.exportData[0])
			}
		},
		downloadFile(data) {
			const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
			if (this.isWebview() && flutterConfig.platform !== 'web') {
				this.flutterDownload(data.fileurl);
			} else {
				window.open(data.fileurl, '_blank');
			}
			this.done()
			setTimeout(() => {
				this.deleteFileExport(data.filename)
			}, 5000)
		},
		downloaded(index) {
			this.$emit("downloaded", index)
		},
		async dismissExport() {
			await this.deleteFileExport()
			this.close()
			this.done()
		},
		async deleteFileExport() {
			await this.$store.dispatch(this.deleteMasterActions)
		}
	}
}
</script>